import React, { useState, useEffect } from 'react'
import { MessageSquare } from 'lucide-react'

const ChatHistoryList = ({ onChatSelect, selectedChatId, setSelectedChatId, onDeleteChat, onTitleChange, chats }) => {
  const handleChatClick = (chatId) => {
    setSelectedChatId(chatId);
    onChatSelect(chatId);
  }
    
  const [showMenu, setShowMenu] = useState(false);
  const [menuChat, setMenuChat] = useState(null);
  const displayMenu = (e, chatId, chatTitle) => {
      e.stopPropagation();
      setMenuChat({id: chatId, chatTitle});
      setShowMenu(true);
  }

  // メニュー外をクリックしたら閉じる処理
  useEffect(() => {
    const handleClickOutside = (event) => {
      // メニューのクリックイベントを無視し、それ以外の場合メニューを閉じる
      if (!event.target.closest('.chat-sidebar-menu') && !event.target.closest('.div-edit-icon')) {
        setShowMenu(false);
      }
    };

    // エスケープキーでメニューを閉じる処理
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setShowMenu(false);
      }
    };

    // クリックイベントとエスケープキーイベントのリスナーを追加
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscKey);

    // クリーンアップでイベントリスナーを削除
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, []);
  

  return (
    <div className="chat-history-div">
      <ul id="chat-hisory">
        {chats.map((chat) => (
          <li
            className={`past-chat ${selectedChatId === chat.chat_id ? 'sidebar-selected' : ''}`}
            key={chat.chat_id}
            onClick={() => handleChatClick(chat.chat_id)}
          >
            <div className='chat-history-container px-2' data-chat-id={chat.chat_id}>
              {/* <div className="img-item">
                <MessageSquare className="chat-sidebar-icon" />
              </div> */}
              <div className="title-item">
                <span>{chat.title}</span>
              </div>
              <div className="div-edit-icon" onClick={(e) => displayMenu(e, chat.chat_id, chat.title)} >
                  ...
                  {(showMenu && menuChat?.id === chat.chat_id) &&
                      <div className='chat-sidebar-menu'>
                          <ul>
                              <li onClick={() => onTitleChange(chat.chat_id, chat.title)}><i className="fa-solid fa-pencil"></i> 名前を変更する</li>
                              <li onClick={() => onDeleteChat(chat.chat_id, chat.title)}><i className="fa-regular fa-trash-can"></i> 削除する</li>
                          </ul>
                      </div>
                      }
              </div>
            </div>
          </li>
        ))}
    </ul>
</div>
  )
}

export default ChatHistoryList